import { FC } from 'react';
import { css } from '@linaria/core';
import { Tooltip } from 'components/Tooltip';
type RVSTooltipProps = {
  text: string;
  children: React.ReactElement;
};
export const RVSTooltip: FC<RVSTooltipProps> = ({
  text,
  children
}: RVSTooltipProps) => {
  if (!children) return null;
  return <Tooltip showArrow initialState={{
    placement: 'top'
  }} data={<div className={VersionSelectorTooltipStyled}>
          <span>{text}</span>
        </div>} className={VersionSelectorTooltipStyled}>
      {children}
    </Tooltip>;
};
const VersionSelectorTooltipStyled = "omponents__PlatformResourceVersionSelector__RVSTooltip_tsx-VersionSelectorTooltipStyled-v1cd4yi0";

require("./RVSTooltip.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./RVSTooltip.tsx");